import { MerchantDetail } from 'lib/shop/types';

export default function MerchantHead({
  merchant,
}: {
  merchant?: MerchantDetail;
}) {
  if (!merchant) return null;

  return (
    <>
      <meta property="og:type" content="article" />
      <meta property="og:title" content={merchant.title} key="title" />
      <meta property="og:image" content={merchant.hero_images?.[0]?.url} />
      <meta
        property="og:description"
        content={merchant.short_description ?? ''}
      />
      <meta property="og:url" content={`/merchants/${merchant.slug}`} />
      <title>{merchant.title}</title>
    </>
  );
}
